// =============================================================================
// MeuDriver — Landing FAQ (Section 8)
// =============================================================================

import { motion } from 'framer-motion'
import * as Accordion from '@radix-ui/react-accordion'
import { ChevronDown } from 'lucide-react'
import { Badge } from '@/components/ui/badge'

const viewportOnce = { once: true, margin: '-80px' }

const FAQ_ITEMS = [
  {
    value: 'faq-1',
    question: 'Como funciona o pagamento das aulas?',
    answer: 'O pagamento é feito de forma segura diretamente pela plataforma MeuDriver. Aceitamos cartão de crédito, débito e Pix. O valor é liberado ao instrutor somente após a conclusão da aula, garantindo segurança para ambos os lados.',
  },
  {
    value: 'faq-2',
    question: 'Como os instrutores são verificados?',
    answer: 'Todos os instrutores passam por um processo de verificação que inclui validação do número de CNH, comprovante de residência e análise de antecedentes. Apenas instrutores aprovados pela nossa equipe ficam visíveis na plataforma.',
  },
  {
    value: 'faq-3',
    question: 'Posso cancelar ou reagendar uma aula?',
    answer: 'Sim! Você pode cancelar ou reagendar uma aula com pelo menos 24 horas de antecedência para receber reembolso integral. Para cancelamentos com até 2 horas de antecedência, é feito reembolso de 50%. Após esse prazo, não há reembolso.',
  },
  {
    value: 'faq-4',
    question: 'As aulas valem para tirar a CNH no DETRAN?',
    answer: 'As aulas com instrutores da MeuDriver são práticas particulares, ideais para complementar o aprendizado do processo de habilitação. Elas não substituem as aulas obrigatórias do DETRAN, mas aumentam muito a confiança e preparo para os exames.',
  },
  {
    value: 'faq-5',
    question: 'Como me cadastro como instrutor de direção?',
    answer: 'Basta clicar em "Quero ser instrutor" e preencher o formulário de cadastro. Após o envio dos documentos necessários (CNH válida, dados do veículo), nossa equipe analisa em até 2 dias úteis. Após aprovação, seu perfil fica disponível para alunos em todo o Brasil.',
  },
]

export function LandingFAQ() {
  return (
    <section className="bg-slate-50/70 py-20 sm:py-24">
      <div className="mx-auto max-w-2xl px-4">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={viewportOnce} transition={{ duration: 0.5 }} className="text-center mb-12">
          <Badge variant="outline" className="mb-3 text-sm px-3 py-1 border-brand-200 text-brand-700">Dúvidas frequentes</Badge>
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl tracking-tight">Perguntas frequentes</h2>
          <p className="mt-3 text-gray-500">Tudo que você precisa saber antes de começar.</p>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={viewportOnce} transition={{ duration: 0.5, delay: 0.15 }}>
          <Accordion.Root type="single" collapsible className="space-y-2.5">
            {FAQ_ITEMS.map((item) => (
              <Accordion.Item
                key={item.value}
                value={item.value}
                className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-soft data-[state=open]:border-brand-200 data-[state=open]:shadow-card transition-all duration-200"
              >
                <Accordion.Header>
                  <Accordion.Trigger className="group flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-sm font-semibold text-gray-800 hover:text-brand-700 transition-colors data-[state=open]:text-brand-700">
                    {item.question}
                    <ChevronDown className="h-4 w-4 shrink-0 text-gray-400 transition-transform duration-200 group-data-[state=open]:rotate-180 group-data-[state=open]:text-brand-600" />
                  </Accordion.Trigger>
                </Accordion.Header>
                <Accordion.Content className="overflow-hidden data-[state=open]:animate-accordion-down data-[state=closed]:animate-accordion-up">
                  <p className="px-5 pb-5 text-sm text-gray-600 leading-relaxed">{item.answer}</p>
                </Accordion.Content>
              </Accordion.Item>
            ))}
          </Accordion.Root>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={viewportOnce} transition={{ duration: 0.5, delay: 0.3 }} className="mt-10 text-center">
          <p className="text-sm text-gray-500">
            Ainda tem dúvidas?{' '}
            <a href="mailto:contato@meudriver.com.br" className="font-semibold text-brand-600 hover:text-brand-700 transition-colors">
              Fale com a gente
            </a>
          </p>
        </motion.div>
      </div>
    </section>
  )
}
